<template>
  <main>
    <ul class="list">
      <li v-for="(v, i) in list" :key="v.id">
        <div class="info" @click="selected(v)">
          <h3><b>{{ v.addressee }}</b><span>{{ v.phone }}</span></h3>
          <p>{{ v | getAddressDesc }}</p>
        </div>
        <div class="options" v-show="type === 'edit'">
          <label :class="{ on: v.is_default === 1 }" @click="setDefault(v, i)">
            <i class="icon-check"></i>
            <span>默认地址</span>
          </label>
          <nav>
            <b @click="$router.push({ name: 'addressSet', params: { info: v} })"><i class="icon-bianji"></i><span>编辑</span></b>
            <b @click="deleteAddress(v.id)"><i class="icon-shanchu"></i><span>删除</span></b>
          </nav>
        </div>
      </li>
    </ul>
    <button v-show="type==='edit'" @click="$router.push({ name: 'addressSet' })">新增地址</button>
  </main>
</template>

<script>
import { MessageBox } from 'mint-ui';
import $address from '@api/address';
export default {
  data () {
    return {
      type: 'edit', // edit = 编辑 | select = 选择
      list: []
    }
  },
  created () {
    const { type = 'edit' } = this.$route.query;
    this.type = type;
    this.getList();
  },
  filters: {
    getAddressDesc (v) {
      const { province, city, district, address } = v;
      return province + city + district + address;
    }
  },
  methods: {
    selected (v) {
      if ( this.type === 'edit' ) { return; }
      sessionStorage.setItem('SelectedAddr', JSON.stringify(v));
      this.$router.back();
    },
    async setDefault (v, i) {
      const data = { ...v, is_default: !v.is_default ? 1 : 0 };
      const res = await $address.change(v.id, data);
      if ( !res.OK ) { this.$toast('修改失败，请稍后再试！'); return; }

      // 重组数组
      const list = data.is_default === 1 ? [...this.list].map(v => {
        v.is_default = 0;
        return v;
      }) : [...this.list];
      list[i].is_default = data.is_default;
      this.list = list;
      this.$toast('修改默认地址成功！');
    },
    async getList () {
      const res = await $address.list();
      this.list = res;
    },
    async deleteAddress (id) {
      try {
        await MessageBox.confirm('是否要删除？！', '提示');
        const res = await $address.change(id, {}, 'DELETE');
        if ( !res.OK ) { this.$toast('删除失败，请稍后再试！'); return; }
        const list = [...this.list].filter(v => v.id !== id);
        this.list = list;
      } catch (e) {
        return false;
      }
    }
  }
}
</script>

<style scoped src="./address.css"></style>